import { __ } from '@wordpress/i18n';
const { RichText, InnerBlocks } = wp.blockEditor;

export default ({ attributes, setAttributes, className }) => {

  const handleOnChangeCardTitleOne = ( title_1 ) => {
    setAttributes({ title_1 });
  };

  const handleOnChangeCardDescriptionOne = ( description_1 ) => {
    setAttributes({ description_1 });
  };

  const handleOnChangeCardLinkOne = ( link_1 ) => {
    setAttributes({ link_1 });
  };

  const handleOnChangeCardTitleTwo = ( title_2 ) => {
    setAttributes({ title_2 });
  };

  const handleOnChangeCardDescriptionTwo = ( description_2 ) => {
    setAttributes({ description_2 });
  };

  const handleOnChangeCardLinkTwo = ( link_2 ) => {
    setAttributes({ link_2 });
  };

  return(
    <div className={ className }>
      <div className="wrapper">
        <InnerBlocks 
        template={[ ['core/heading'] ]}
        templateLock="all"
        />

        <div className="card">
          <RichText
          tagName="p"
          className="card__title"
          placeholder={__("Preencha o título")}
          value={attributes.title_1}
          onChange={handleOnChangeCardTitleOne}
          />

          <RichText
          tagName="p"
          className="card__description"
          placeholder={__("Preencha a descrição")}
          value={attributes.description_1}
          onChange={handleOnChangeCardDescriptionOne}
          />

          <RichText
          tagName="a"
          className="card__link"
          placeholder={__("Preencha o link")}
          value={attributes.link_1}
          onChange={handleOnChangeCardLinkOne}
          />
        </div>

        <div className="card">
          <RichText
          tagName="p"
          className="card__title"
          placeholder={__("Preencha o título")}
          value={attributes.title_2}
          onChange={handleOnChangeCardTitleTwo}
          />

          <RichText
          tagName="p"
          className="card__description"
          placeholder={__("Preencha a descrição")}
          value={attributes.description_2}
          onChange={handleOnChangeCardDescriptionTwo}
          />

          <RichText
          tagName="a"
          className="card__link"
          placeholder={__("Preencha o link")}
          value={attributes.link_2}
          onChange={handleOnChangeCardLinkTwo}
          />
        </div>
      </div>
    </div>
  );
}
